import './vendor';
import './_app.styles/import.scss';

import 'utility/import-angular-templates';
import 'utility/import-angular-dependencies';

import common from './common/common';
import call from './modules/call/call';
import callMobile from './modules/call-mobile/call-mobile';
import global from './global/global.index';

import providers from './providers/providers';
import realtime from './realtime/realtime';
import videoChat from './video-chat/video-chat';
import doxyRedux from './store';
import datadogRum from './utility/datadog-util';
import banners from './modules/banners/banners';
import sso from './modules/sso/sso';
import sidebar from './modules/sidebar/sidebar';

datadogRum.onReady(() => {
  datadogRum.startSessionReplayRecording();
});

/* mute @formatjs/intl defaultRichTextElements pre-compiled warning */
const consoleWarn = console.warn.bind(console);
const ignoredWarnLogs = [
  '[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled.',
];
console.warn = (message, ...args) => {
  if (
    typeof message === 'string' &&
    ignoredWarnLogs.some((ignoredWarnLog) => message.startsWith(ignoredWarnLog))
  ) {
    return;
  }
  consoleWarn(message, ...args);
};

const main = angular
  .module('doxy', [
    'doxy.vendors',
    'doxy.templates',
    common,
    call,
    callMobile,
    global,
    providers,
    realtime,
    videoChat,
    doxyRedux.name,
    banners,
    sso,
    sidebar,
  ])
  .constant('doxyVersion', { platform: 'web', version: 1 }).name;

// Temporary solution: after removing service workers we have to unload the previously loaded SW
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          if (registration.active?.scriptURL.includes('/sw.js')) {
            void registration.unregister();
          }
        }
        return null;
      })
      .catch((err) => console.log(err));
  });
}

export default main;
